import config from "../../config/config.json";
import { useDocumentTitle } from "../../hooks/use-document-title";
import "./TermsOfServicePage.scss";

export default function TermsOfServicePage() {
  useDocumentTitle("Terms of Service");

  const contactEmail = config.contactEmail;

  return (
    <div className="terms-of-service-page-container">
      <h1>Terms of Service</h1>
      <p>Last updated: July 29, 2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Calendar Automation ("Service", "we", "our",
        "us"), you agree to be bound by these Terms of Service ("Terms"). If you
        do not agree to all of these Terms, you may not access or use the
        Service.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        Calendar Automation is a web application that connects to your Google
        Calendar to answer questions about your events and, at your request,
        create new events on your behalf.
      </p>

      <h2>3. Google Calendar Integration</h2>
      <p>
        In order to provide the Service, Calendar Automation requires permission
        to read, create, and update events in your Google Calendar. You grant
        these permissions when you sign in with your Google account. You may
        revoke access at any time through your Google Account security settings.
      </p>
      <p>
        Calendar Automation will only perform the following actions when
        explicitly triggered by you:
      </p>
      <ul>
        <li>Read events on the calendars you select.</li>
        <li>Create new events with the details you provide.</li>
        <li>Provide summaries or answers based on your existing events.</li>
      </ul>

      <h2>4. User Responsibilities</h2>
      <ul>
        <li>
          You must ensure that any information you provide is accurate and
          complete.
        </li>
        <li>You are responsible for any events created through the Service.</li>
        <li>You must not use the Service for unlawful or harmful purposes.</li>
      </ul>

      <h2>5. Privacy</h2>
      <p>
        Your privacy is important to us. Please review our{" "}
        <a href="/privacy-policy">Privacy Policy</a> to understand how we
        collect, use, and protect your information.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        The Service and all content therein, excluding user-provided
        information, is owned by Calendar Automation and protected by
        intellectual property laws. You may not reproduce, distribute, or create
        derivative works without our prior written consent.
      </p>

      <h2>7. Disclaimer of Warranties</h2>
      <p>
        The Service is provided "as is" and "as available" without warranties of
        any kind, whether express or implied. We do not guarantee that the
        Service will be available, uninterrupted, or error-free.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Calendar Automation will not be
        liable for any indirect, incidental, special, consequential or punitive
        damages, or any loss of profits or revenues, arising out of or related
        to your use of the Service.
      </p>

      <h2>9. Indemnification</h2>
      <p>
        You agree to indemnify and hold Calendar Automation harmless from any
        claims, damages, or expenses arising from your use of the Service or
        violation of these Terms.
      </p>

      <h2>10. Termination</h2>
      <p>
        We may suspend or terminate your access to the Service at any time for
        any reason, including violation of these Terms.
      </p>

      <h2>11. Changes to Terms</h2>
      <p>
        We may modify these Terms at any time. We will notify you of material
        changes by posting the updated Terms on this page. Your continued use of
        the Service after such modifications constitutes acceptance of the new
        Terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms are governed by and construed in accordance with the laws of
        the State of New York, without regard to its conflict of law principles.
      </p>

      <h2>13. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at{" "}
        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
      </p>
    </div>
  );
}
